import $ from "jquery";
import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import Comm from "../comm/comm";
import Context from "../context/context";
import Translation from "../translation/translation";

class Users extends Component {
    allChecked = false;
    constructor(props) {
        super(props);
        if (!Comm.ValidSession()) return;

        var sid = Context.GetContext().Sid;
        this.state = {
            Users: Comm.Users(sid),
            Groups: Comm.Groups(sid),
            Permissions: Comm.Permissions(sid).sort((a,b)=>Translation.Trans(a).localeCompare(Translation.Trans(b))),
            SelectedUser: null,
            showMissingNameError: false,
            showMissingPassError: false,
        };
        this.ToggleAll = this.ToggleAll.bind(this);
    }

    ShowUser(user) {
        this.setState({ SelectedUser: user, showMissingNameError: false, showMissingPassError: false });
    }

    NewUser() {
        this.setState({
            SelectedUser: {
                id: null,
                username: "",
                name1: "",
                name2: "",
                name3: "",
                position: "",
                permissions: {},
                groups: [],
                groupids: [],
            },
        });
    }

    ToggleAll() {
        this.allChecked = !this.allChecked;
        var ch = this.allChecked;
        $("input[id^='cbPermission']").each(function (i, e) {
            $(e).prop("checked", ch);
        });
    }

    Save() {
        var un = this.state.SelectedUser.username;
        if (un === "") {
            this.setState({ showMissingNameError: true });
            return;
        }

        var pass = this.state.SelectedUser.password;
        if (pass === "" && this.state.SelectedUser.id === null) {
            this.setState({ showMissingPassError: true });
            return;
        }

        var sid = Context.IsLogged().Sid;
        var data = {
            id: this.state.SelectedUser.id,
            username: un,
            name1: this.state.SelectedUser.name1,
            name2: this.state.SelectedUser.name2,
            name3: this.state.SelectedUser.name3,
            position: this.state.SelectedUser.position,
            permissions: {},
            groups: [],
        };
        if (pass !== "") data.password = pass;

        $("input[id^='cbPermission']:checked").each(function (i, e) {
            var val = $(e).attr("permvalue");
            data.permissions[val] = 1;
        });

        $("input[id^='cbGroup']:checked").each(function (i, e) {
            var val = $(e).attr("groupvalue");
            data.groups.push({ id: parseInt(val, 10) });
        });
        sid = Context.GetContext().Sid;

        Comm.SaveUser(sid, data);
        this.setState({
            Users: Comm.Users(sid),
            SelectedUser: null,
            showError: false,
            showMissingNameError: false,
            showMissingPassError: false,
        });
    }

    render() {
        if (!Comm.ValidSession()) {
            Context.Logout();
            return <Redirect to="/login" push></Redirect>;
        }

        var self = this;
        if (Context.RenderNotOK(this.props.history)) return null;

        var users = this.state.Users.slice();

        return Context.HasRight("rusers") === true ? (
            <div className="panel panel-default">
                <div className="panel-heading">{Translation.Trans("users")}</div>
                <div className="panel-body">
                    {Context.HasRight("eusers") ? (
                        <button className="btn btn-primary" onClick={() => this.NewUser()}>
                            {Translation.Trans("newuser")}
                        </button>
                    ) : null}

                    <br />
                    <br />
                    <br />
                    <div className="row">
                        <div className="col-md-2">
                            {users.map((obj) => (
                                <p
                                    key={obj.id}
                                    className={
                                        this.state.SelectedUser !== null &&
                                        this.state.SelectedUser.id === obj.id
                                            ? "btn btn-warning"
                                            : null
                                    }
                                >
                                    <a onClick={() => this.ShowUser(obj)} className="pointhand">
                                        {obj.username}
                                    </a>
                                </p>
                            ))}
                        </div>
                        <div className="col-md-10">
                            {this.state.SelectedUser !== null ? (
                                <div id="dData" className="borderDiv">
                                    <div className="row">
                                        <div className="col-md-12">
                                            {Context.HasRight("eusers") === true ? (
                                                <button
                                                    className="btn btn-primary pull-right"
                                                    onClick={() => this.Save()}
                                                >
                                                    {Translation.Trans("save")}
                                                </button>
                                            ) : null}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-10">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder={Translation.Trans("username")}
                                                value={this.state.SelectedUser.username}
                                                onChange={(e) => {
                                                    var u = self.state.SelectedUser;
                                                    u.username = e.target.value;
                                                    self.setState({ SelectedUser: u });
                                                }}
                                            ></input>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-10">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder={Translation.Trans("firstname")}
                                                value={this.state.SelectedUser.name1 || ""}
                                                onChange={(e) => {
                                                    var u = self.state.SelectedUser;
                                                    u.name1 = e.target.value;
                                                    self.setState({ SelectedUser: u });
                                                }}
                                            ></input>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-10">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder={Translation.Trans("middlename")}
                                                value={this.state.SelectedUser.name2 || ""}
                                                onChange={(e) => {
                                                    var u = self.state.SelectedUser;
                                                    u.name2 = e.target.value;
                                                    self.setState({ SelectedUser: u });
                                                }}
                                            ></input>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-10">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder={Translation.Trans("lastname")}
                                                value={this.state.SelectedUser.name3 || ""}
                                                onChange={(e) => {
                                                    var u = self.state.SelectedUser;
                                                    u.name3 = e.target.value;
                                                    self.setState({ SelectedUser: u });
                                                }}
                                            ></input>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-10">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder={Translation.Trans("position")}
                                                value={this.state.SelectedUser.position || ""}
                                                onChange={(e) => {
                                                    var u = self.state.SelectedUser;
                                                    u.position = e.target.value;
                                                    self.setState({ SelectedUser: u });
                                                }}
                                            ></input>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-10">
                                            {this.state.showMissingNameError ? (
                                                <div className="alert alert-danger">
                                                    {Translation.Trans("entervalue")}
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-10">
                                            <input
                                                type="password"
                                                className="form-control"
                                                placeholder={Translation.Trans("password")}
                                                value={this.state.SelectedUser.password}
                                                onChange={(e) => {
                                                    var u = self.state.SelectedUser;
                                                    u.password = e.target.value;
                                                    self.setState({ SelectedUser: u });
                                                }}
                                            ></input>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-10">
                                            {this.state.showMissingPassError ? (
                                                <div className="alert alert-danger">
                                                    {Translation.Trans("entervalue")}
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-12">
                                            <a onClick={() => this.ToggleAll()} className="pointhand">
                                                {Translation.Trans("all")}
                                            </a>
                                        </div>
                                        <div className="col-md-6">
                                            {this.state.Permissions.map((obj) => (
                                                <div className="checkbox">
                                                    <input
                                                        id={"cbPermission" + obj}
                                                        type="checkbox"
                                                        permvalue={obj}
                                                        key={obj + "_" + this.state.SelectedUser.id}
                                                        defaultChecked={
                                                            this.state.SelectedUser.permissions !== null &&
                                                            this.state.SelectedUser.permissions.hasOwnProperty(
                                                                obj
                                                            )
                                                        }
                                                    />
                                                    <label for={"cbPermission" + obj}>
                                                        {Translation.Trans(obj)}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                        <div className="col-md-6">
                                            {this.state.Groups.map((obj) => (
                                                <div className="checkbox">
                                                    <input
                                                        id={"cbGroup" + obj.id}
                                                        type="checkbox"
                                                        groupvalue={obj.id}
                                                        key={"gr" + obj + "_" + this.state.SelectedUser.id}
                                                        defaultChecked={
                                                            this.state.SelectedUser.groupids.indexOf(obj.id) >
                                                            -1
                                                        }
                                                    />
                                                    <label for={"cbGroup" + obj.id}>{obj.name}</label>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
        ) : (
            <div>{Translation.Trans("noRights")}</div>
        );
    }
}

export default Users;



// WEBPACK FOOTER //
// ./src/pages/users.js